import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

interface UseTile {
  title: string;
}

export function usePageTitle(): UseTile {
  const [title, setTitle] = useState<string>('');
  const location = useLocation();

  useEffect((): void => {
    const _title = location.pathname.split('/').pop();

    if (_title) {
      const _titleWithoutHyphen = _title.split('-');

      const _titleWordsCapitalized = _titleWithoutHyphen.map(
        word => word.charAt(0).toUpperCase() + word.slice(1)
      );

      setTitle(_titleWordsCapitalized.join(' '));
    }
  }, [location.pathname]);

  return {
    title,
  };
}
